import { MENU_STYLES } from '../../constants/MenuConstants.js';

export class MenuItems {
    constructor(model) {
        this.model = model;
    }

    populateMenuItems(ul, items, existingStyles = []) {
        if (!ul.components || typeof ul.components !== 'function') {
            return;
        }

        items.forEach((item, index) => {
            this.createMenuItem(ul, item, index, existingStyles[index]);
        });
    }

    createMenuItem(ul, item, index, existingStyle) {
        const itemName = item.label || item.name || 'Unnamed';
        const hasChildren = item.items && item.items.length > 0;
        const itemId = item.value || itemName || `item-${index}`;

        const li = ul.components().add({
            tagName: 'li',
            attributes: {
                class: `menu-item ${hasChildren ? 'has-children' : ''}`,
                'data-menu-item': itemId,
                'data-menu-type': item?.type,
                'data-item-index': index
            },
            style: {
                ...(existingStyle || MENU_STYLES.menuItem),
            }
        });

        if (li.components && typeof li.components === 'function') {
            li.components().add({
                tagName: 'span',
                attributes: { class: 'menu-item-text' },
                content: itemName,
            });
        }
    }

    updateMenuItemsConditionally(ul, items) {
        if (!ul.components || typeof ul.components !== 'function') {
            return;
        }

        const existingList = ul.components().models || [];
        const currentItems = items || [];
        const existingStyles = this.extractExistingItemStyles(existingList);

        if (this.canReuseExistingItems(existingList, currentItems)) {
            return;
        }

        ul.components().reset();
        this.populateMenuItems(ul, items, existingStyles);
    }

    extractExistingItemStyles(existingList) {
        return existingList.map((li) => {
            if (!li || typeof li.getStyle !== 'function') {
                return null;
            }

            const currentStyle = li.getStyle();
            return currentStyle && Object.keys(currentStyle).length > 0
                ? currentStyle
                : null;
        });
    }

    canReuseExistingItems(existingList, currentItems) {
        if (existingList.length !== currentItems.length) {
            return false;
        }

        let canReuseAll = true;

        existingList.forEach((li, index) => {
            if (index < currentItems.length) {
                const item = currentItems[index];
                this.updateExistingMenuItem(li, item, index);
            } else {
                canReuseAll = false;
            }
        });

        return canReuseAll;
    }

    updateExistingMenuItem(li, item, index) {
        const itemName = item.label || item.name || 'Unnamed';
        const hasChildren = item.items && item.items.length > 0;
        const itemId = item.value || itemName || `item-${index}`;

        li.addAttributes({
            'data-menu-item': itemId,
            'data-menu-type': item?.type,
            'data-item-index': index,
            class: `menu-item ${hasChildren ? 'has-children' : ''}`
        });

        this.updateLiContent(li, itemName, hasChildren);
    }

    updateLiContent(li, itemName, hasChildren) {
        if (!li.components || typeof li.components !== 'function') {
            return;
        }

        const spans = li.components().models || [];
        let textSpan = spans.find(span => {
            const attrs = span.getAttributes();
            return attrs.class && attrs.class.includes('menu-item-text');
        });

        if (textSpan) {
            textSpan.set('content', itemName);
        } else {
            li.components().add({
                tagName: 'span',
                attributes: { class: 'menu-item-text' },
                content: itemName,
            });
        }
    }
}